import { authInstance } from './axios'
let url = process.env.REACT_APP_API_URL

export const trackingsService = {
  changeSolved: async (data, serviceId) => {
    const response = await authInstance
      .put(`${url}/serviceTripTracking/${serviceId}/trackings`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },
}
